export class SetTags {
  static readonly type = '[TagState] SetTags';
  constructor(public readonly tags: string[]) {}
}
